import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { IHandoverReportResponse } from 'types/api/operationsHandoverApi.interface'
import { IOpsHandoverSlice } from 'types/opsHandover.interface'
import { baseUrl } from 'utils/axios'
import { handleErrors } from 'utils/helpers'
import { mapHandoverReport } from 'pages/Operations/Shared/opsApiMappers'
import { USE_OPS_MOCKS } from 'pages/Operations/Shared/opsControl'
import { demoHandover } from 'pages/Operations/Shared/opsApiDemoCore'

const initialState: IOpsHandoverSlice = {
  isLoading: false,
  report: null,
  loaded: false,
}

export const getHandoverReport = createAsyncThunk(
  'opsHandover/getHandoverReport',
  async (params: any, thunkAPI) => {
    if (USE_OPS_MOCKS) return demoHandover()
    try {
      const resp: AxiosResponse<IHandoverReportResponse> = await baseUrl.get(
        'aim-operations/handover/report',
        { params },
      )
      return resp.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

const opsHandoverSlice = createSlice({
  name: 'opsHandover',
  initialState,
  reducers: {
    clearOpsHandover: () => initialState,
  },
  extraReducers: {
    [getHandoverReport.pending.type]: (state) => {
      state.isLoading = true
    },
    [getHandoverReport.fulfilled.type]: (
      state,
      { payload }: { payload: IHandoverReportResponse },
    ) => {
      state.isLoading = false
      state.loaded = true
      state.report = mapHandoverReport(payload)
    },
    [getHandoverReport.rejected.type]: (state, action) => {
      state.isLoading = false
      state.loaded = true
      state.report = null
      handleErrors(action.payload)
    },
  },
})

export const { clearOpsHandover } = opsHandoverSlice.actions
export default opsHandoverSlice.reducer
